import EditBlog from "../Components/EditBlog";

export default function Edit() {
  return (
    <div>
      <EditBlog/>
    </div>
  )
}
